import Store from '../store';

const loadConfig = async(to, from, next) => {
    try {
        await Store.dispatch("Config/getConfig");
        await Store.dispatch("Config/getDialetos");
        await Store.dispatch("Config/listarMenu");
    } catch(err) {
        console.error(err)
    }
    
    next();
}

export default loadConfig;